import { IMAGE_SELECTOR } from '../../hdrm/constants/image-selector';
import getAssetsUrl from '../../site/accessors/get-assets-url';

const isExternalImage = (image) => {
  const hasSource = Boolean(image.getAttribute('src'));
  const isMediaContainer = image.closest(IMAGE_SELECTOR);

  const assetUrlOrigin = new URL(getAssetsUrl()).origin;
  const imageOrigin = new URL(image.src).origin;
  const { location } = window;

  const isInternal = assetUrlOrigin === imageOrigin || location.origin === imageOrigin;
  return isMediaContainer ? !isInternal : hasSource;
};

export default isExternalImage;
